import apiFetch from '../apiFetch'

export default function (token, dossierId, idx) {
  return apiFetch({ endPoint: `Audit/Historical/GroupedDocuments/Details?dossierId=${dossierId}&idx=${idx}`, method: 'GET', body: null, token: token })
}
